import { useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as ArrowRight } from '@elementary/common-ui/assets/arrow-right-tree.svg';
import { Accordion, Button, Flex } from '@elementary/common-ui/components';
import { AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { radius, space } from '@elementary/common-ui/style/utils';

const StyledAccordionDetails = styled(AccordionDetails)`
  display: flex;
  align-items: center;
  gap: ${space('lg')};
  background-color: ${({ theme }) => theme.palette.surface.tinted};
  padding: ${space('lg')};
  border-radius: ${radius('lg')};
`;

const CommandText = styled.span`
  color: ${({ theme }) => theme.palette.status.warning.accent};
`;

type Props = {
  reloadOnClick: () => void;
};

const MissingChannelHelper = ({ reloadOnClick }: Props) => {
  const [expanded, setExpanded] = useState<string | false>('');

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  return (
    <Flex sx={{ gap: 1, alignItems: 'center' }}>
      <Accordion
        expanded={expanded === 'panel1'}
        onChange={handleChange('panel1')}
        sx={{
          '& . MuiPaper': {
            width: '100%',
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ArrowRight />}
          sx={{
            flexDirection: 'row-reverse',
            gap: 1,
            '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
              transform: 'rotate(90deg)',
            },
          }}
        >
          <Typography variant="body2">Can’t find relevant channel?</Typography>
        </AccordionSummary>
        <StyledAccordionDetails>
          <Typography>
            This might be because your channel is private. To resolve it, open
            the channel on Slack, send the message{' '}
            <CommandText>@Elementary</CommandText>, and click “Invite Them”.
            Then click “Reload” to refresh the channels.
          </Typography>
          <Button variant="contained" color="secondary" onClick={reloadOnClick}>
            Reload
          </Button>
        </StyledAccordionDetails>
      </Accordion>
    </Flex>
  );
};

export default MissingChannelHelper;
